import React, { useEffect, useState } from 'react'
import { Box, Container, Grid, Typography } from '@mui/material'
// import { styled } from '@mui/material/styles';
import Marquee from "react-fast-marquee";
import { _fetchData } from 'ethers/lib/utils';
import { color } from 'highcharts';
import axios from 'axios';
import bitcoin from '../../../../assets/images/bitcoin.png';
import usdt from '../../../../assets/images/usdt.png';
import busd from '../../../../assets/images/busd.png';
import link from '../../../../assets/images/link.png';
import smallbnb from '../../../../assets/images/smallbnb.png';

export default function MarqueeCard({ apidata }) {
    const [coinprice, setCoinPrice] = useState([]);

    useEffect(() => {
        async function fetchPrice() {
            let priceData = await fetch(
                `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=100&page=1&sparkline=false`,
                {
                    method: "get"
                }
            );
            const rowData = await priceData.json()
            let items = rowData.filter((v) => {
                if (v.id == "bitcoin" || v.id == "binancecoin" || v.id == "chainlink" || v.id == "binance-usd" || v.id == "tether") {
                    return v;
                }
            })
            setCoinPrice(items)
            // setCoinPrice({
            //     bnb: rowData[4],
            //     btc: rowData[0],
            //     link: rowData[23],
            //     busd: rowData[5],
            //     usdt: rowData[2],
            // })
        }
        fetchPrice();
    }, []);

    const [data, setData] = useState([{}]);

    useEffect(() => {
        async function fetchData() {
            let rspData = await fetch(
                `https://api.coingecko.com/api/v3/global`,
                {
                    method: "get",
                }
            );
            const row = await rspData.json()

            let dominance = {}
            let gasFee = {}
            let marketCap = {}
            let totalVolume = {}
            dominance["market"] = 'Dominance'
            dominance["price"] = `BTC: ${(row.data.market_cap_percentage.btc).toFixed(2)}% ETH: ${(row.data.market_cap_percentage.eth).toFixed(2)}% USDT: ${(row.data.market_cap_percentage.usdt).toFixed(2)}% BNB: ${(row.data.market_cap_percentage.bnb).toFixed(2)}% USDC: ${(row.data.market_cap_percentage.usdc).toFixed(2)}%`

            let cryptoMarketCap = row.data.total_market_cap;
            const keys = Object.keys(cryptoMarketCap);
            let total = 0
            for (var key of keys) {
                total += cryptoMarketCap[key]
            }

            let volume = row.data.total_volume;
            const volumekeys = Object.keys(volume);
            let totalvolume = 0
            for (var key of volumekeys) {
                totalvolume += volume[key]
            }


            gasFee["market"] = 'ETH Gas Fee'
            gasFee["price"] = '0.002'
            marketCap["market"] = 'Crypto Market Cap'
            marketCap["price"] = `$ ${total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            totalVolume["market"] = 'Crypto 24h Vol'
            totalVolume["price"] = `$ ${totalvolume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            // marketData["market"] = 'Crypto Market Cap'
            let tObj = [dominance, gasFee, marketCap, totalVolume]
            setData(tObj);


            // let fprice = parseFloat(row["price"].replace("$", ""))

            // const keys = Object.keys();
        }
        fetchData();
    }, [])


    // const item = [{ market: coinprice.bnb.symbol, img: smallbnb, price: coinprice.bnb.current_price }, { market: coinprice.link.symbol, img: coinprice.link.image, price: coinprice.link.current_price }, { market: coinprice.busd.symbol, img: coinprice.busd.image, price: coinprice.busd.current_price }, { market: coinprice.usdt.symbol, img: coinprice.usdt.image, price: coinprice.usdt.current_price }, { market: coinprice.btc.symbol, img: coinprice.btc.image, price: coinprice.btc.current_price }];

    return (
        <Box sx={{ background: '#1A3342', border: '2px solid #00FED9', borderRadius: 5, m: 1, minWidth: { xl: '30vw' } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', color: 'white', px: 2, overflow: 'hidden' }}>

                <Box sx={{
                    display: 'flex',
                    py: '18px',
                    borderBottom: '1px solid rgba(0, 254, 217, 0.4)',
                    overflow: 'hidden',
                }}>
                    <Marquee gradient={false} speed={30}>
                        <Box sx={{
                            display: 'flex', fontSize: '10px', overflow: 'hidden', gap: '24px', mr: '24px'
                        }}>
                            {
                                coinprice.map((value?: any, index?: number) => {
                                    return (<Box key={index} sx={{ display: 'flex', justifyContent: 'space-around', gap: '5px', alignItems: 'center', textTransform: 'uppercase', }}>
                                        <img src={value.image} width="12px" height="12px" />
                                        <Box sx={{ fontWeight: 400, letterSpacing: '1px' }}>
                                            {value.symbol}
                                        </Box>
                                        <Box sx={{ display: 'flex', fontWeight: 'bolder', letterSpacing: '1px' }}>
                                            ${value.current_price}
                                        </Box>
                                    </Box>);
                                })
                            }

                        </Box>
                    </Marquee>
                </Box>
                <Grid container spacing={0} sx={{
                    justifyContent: { xs: 'space-between' },
                    // display: 'flex',
                    // overflow: 'hidden',
                    minWidth: { xs: '335px', sm: '625px', lg: '0px', md: '0px', xl: '0px' },
                }}>

                    <Grid item xs={6} sm={3} md={3} sx={{ borderRight: { xs: '1px solid rgba(0, 254, 217, 0.4)', sm: '1px solid rgba(0, 254, 217, 0.4)', md: '1px solid rgba(0, 254, 217, 0.4)' } }} >
                        <Box sx={{ flexGrow: 1, pl: 1, py: 2 }}>
                            <Box sx={{ whiteSpace: 'nowrap', fontSize: '10px', color: '#B1B3CB', fontWeight: 800 }}>$DVX Market Cap</Box>
                            <Box sx={{ fontSize: '18px', fontWeight: 800, overflow: 'hidden' }}>{apidata["mc"]}</Box>
                            {/* <Box sx={{ fontSize: '10px', color: 'green' }}>{apidata["change"]}</Box> */}
                            <div className={`text-xs ${parseFloat(apidata['change']?.substring(0, apidata['change'].length - 1)) >= 0 ? 'green-api' : 'red-api'}`}>{apidata['change']}</div>
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} sx={{ borderRight: { xs: 'none', sm: '1px solid rgba(0, 254, 217, 0.4)', md: '1px solid rgba(0, 254, 217, 0.4)' } }}>
                        <Box sx={{ flexGrow: 1, pl: { xs: 2, sm: 1, md: 1, lg: 1 }, py: 2 }}>
                            {/* <Box sx={{ flexGrow: 1,  pl:1 ,pr:{xs:2,sm:0,md:0,lg:0,xl:0}, py: 2, borderRight: { xs: 'none', sm: '1px solid #00FED9', md: '1px solid #00FED9' } }}> */}
                            <Box sx={{ whiteSpace: 'nowrap', fontSize: '10px', color: '#B1B3CB', fontWeight: 800 }}>Total BUSD Rewarded</Box>
                            <Box sx={{ fontSize: '18px', fontWeight: 800, overflow: 'hidden' }}>{apidata["rewarded"]}</Box>
                            {/* <Box sx={{ fontSize: '10px', color: 'red' }}>-2.00%</Box> */}
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} sx={{ borderTop: { xs: '1px solid rgba(0, 254, 217, 0.4)', sm: 'none', md: 'none' }, borderRight: { xs: '1px solid rgba(0, 254, 217, 0.4)', sm: '1px solid rgba(0, 254, 217, 0.4)', md: '1px solid rgba(0, 254, 217, 0.4)' } }}>
                        {/* <Grid item xs={false} sm={3} md={3} sx={{ borderTop: { xs: 'none',sm: 'none', md: 'none' } }}> */}
                        <Box sx={{ flexGrow: 1, pl: 1, py: 2 }}>
                            <Box sx={{ whiteSpace: 'nowrap', fontSize: '10px', color: '#B1B3CB', fontWeight: 800 }}>Circulating Supply</Box>
                            <Box sx={{ fontSize: '18px', fontWeight: 800, overflow: 'hidden' }}>{apidata["circ"]}</Box>
                        </Box>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} sx={{ borderTop: { xs: '1px solid rgba(0, 254, 217, 0.4)', sm: 'none', md: 'none' } }}>
                        {/* <Grid item xs={false} sm={3} md={3} sx={{ borderTop: { xs: 'none',sm: 'none', md: 'none' } }}> */}
                        <Box sx={{ flexGrow: 1, pl: 1, py: 2 }}>
                            <Box sx={{ whiteSpace: 'nowrap', fontSize: '10px', color: '#B1B3CB', fontWeight: 800 }}>$DVX % Staked</Box>
                            <Box sx={{ fontSize: '18px', fontWeight: 800, overflow: 'hidden' }}>{apidata["stakedPercentage"]}%</Box>
                            <Box sx={{ fontSize: '10px', color: 'green' }}>+2.10%</Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{
                    display: 'flex',
                    py: '18px',
                    overflow: 'hidden',
                    borderTop: '1px solid rgba(0, 254, 217, 0.4)',

                }}>
                    <Marquee gradient={false} speed={50}>
                        <Box sx={{
                            display: 'flex', fontSize: '10px', overflow: 'hidden', gap: '24px', mr: '24px'
                        }}>
                            {
                                data.map((value?: any, index?: number) => {
                                    return (<Box key={index} sx={{ display: 'flex', justifyContent: 'space-around', gap: '5px', alignItems: 'center', textTransform: 'uppercase', }}>
                                        <Box sx={{ fontWeight: 400, letterSpacing: '1px' }}>
                                            {value.market}
                                        </Box>
                                        <Box sx={{ display: 'flex', fontWeight: 'bolder', letterSpacing: '1px' }}>
                                            {value.price}
                                        </Box>
                                    </Box>);
                                })
                            }

                        </Box>
                    </Marquee>
                </Box>

            </Box>
        </Box >
    );
}
